import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import { useTranslation } from "react-i18next";
import { Flex, Switch } from "antd";
import i18n from 'i18next';

import FormHeader from "../form/FormHeader";
import FormText from "../form/FormText";
import FormTitle from "../form/FormTitle";
import FormRemark from "../form/FormRemark";
import FormBigCheckbox2 from "../form/FormBigCheckbox2";
import Divider from "../core/Divider";
import Space from "../core/Space";
import FormButton from "../form/FormButton";
import FormLabel from "../form/FormLabel";
import FormField from "../form/FormField";
import FormInput from "../form/FormInput";
import FormCheckbox from "../form/FormCheckbox";
import FormButtonPrimary from "../form/FormButtonPrimary";
import useApplyNewStore from "../../store/useApplyNewStore";
import ShadowBox from "../core/ShadowBox";
import FormInputError from "../form/FormInputError";
import useViewStore from "../../store/useViewStore";
import Link from "../core/Link";
import { isProduction } from "../../setting";

function Step3() {
  const { t } = useTranslation();
  const { goBackStep, goNextStep } = useApplyNewStore();
  const { step3_email, step3_email_error, setStep3_email, setStep3_email_error } = useApplyNewStore();
  const { step3_mobile, step3_mobile_error, setStep3_mobile, setStep3_mobile_error } = useApplyNewStore();
  const { step3_email_confirm, step3_email_confirm_error, setStep3_email_confirm, setStep3_email_confirm_error } = useApplyNewStore();
  const { step3_mobile_confirm, step3_mobile_confirm_error, setStep3_mobile_confirm, setStep3_mobile_confirm_error } = useApplyNewStore();
  const { step3_sync, setStep3_sync } = useApplyNewStore();
  const { step3_Q1, step3_Q1Error, setStep3_Q1, setStep3_Q1Error } = useApplyNewStore();
  const { step3_Q4, setStep3_Q4 } = useApplyNewStore();
  const { step3_Q5, step3_Q5Error, setStep3_Q5, setStep3_Q5Error } = useApplyNewStore();
  const { step3_Q6, step3_Q6Error, setStep3_Q6, setStep3_Q6Error } = useApplyNewStore();
  const { step3_Q7, step3_Q7Error, setStep3_Q7, setStep3_Q7Error } = useApplyNewStore();
  const { step3_scrollTo, setStep3_scrollTo } = useApplyNewStore();
  const { isStep3Valid, validateStep3, saveFormStep3 } = useApplyNewStore();

  const { isMobileView, isPadView } = useViewStore();

  const nodeRefEmail = useRef(null);
  const nodeRefMobile = useRef(null);
  const nodeRefSync = useRef(null);
  const nodeRef1 = useRef(null)
  const nodeRef2 = useRef(null)

  useEffect(() => {
    const scrollToField = (fieldRef) => {
      fieldRef.current.scrollIntoView({ behavior: 'smooth' });
      setStep3_scrollTo("");
    };

    const fieldRefs = {
      email: nodeRefEmail,
      mobile: nodeRefMobile,
      sync: nodeRefSync,
    };

    if (step3_scrollTo && fieldRefs[step3_scrollTo]) {
      scrollToField(fieldRefs[step3_scrollTo]);
    }
  }, [step3_scrollTo]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleOptionClick = (option) => {
    if (option === 1 && step3_Q4 === "spouse_children") {
      setStep3_Q6("");
      setStep3_Q6Error(false);
      setStep3_Q7("");
      setStep3_Q7Error(false);
    } else if (option === 2 && step3_Q4 === "person") {
      setStep3_Q5("");
      setStep3_Q5Error(false);
    }

    setStep3_Q4(option === 1 ? "person" : "spouse_children");
  };

  return (
    <Container>
      <PageTitle>
        <FormHeader style={{ margin: 0 }}>{t("translation:apply.step3.title")}</FormHeader>
      </PageTitle>

      <Content>
        <PreviousPageBtn onClick={goBackStep}>
          <Img24 src={`${process.env.PUBLIC_URL}/images/arrow_l.svg`} alt={t("previous")} />
          <PreviousPageBtnText>{t("previous")}</PreviousPageBtnText>
        </PreviousPageBtn>

        <Section>
          <Flex gap={8} align="center">
            <Img32 src={`${process.env.PUBLIC_URL}/images/document-envelope.svg`} alt={t("translation:apply.step3.section1.title")} />
            <FormTitle>{t("translation:apply.step3.section1.title")}</FormTitle>
          </Flex>

          <FormText>{t("translation:apply.step3.section1.subtitle")}</FormText>

          <FormField ref={nodeRefEmail} style={{ marginBottom: 0, width: "100%", scrollMarginTop: 230 }}>
            <FormLabelBold htmlFor="step3_email">{t("translation:apply.step3.section1.Q1")}</FormLabelBold>
            <FormInput id="step3_email" value={step3_email} onPaste={(e) => {
              e.preventDefault()
              return false;
            }} handleChange={e => {
              setStep3_email(e.target.value.toLowerCase());
              setStep3_email_error(false);
              validateStep3(true);
            }} placeholder={t("pleaseInput", { key: t("translation:apply.step3.section1.Q1") })} aria-label={t("translation:apply.step3.section1.Q1")} />
            <FormInputError show={step3_email_error}>* {t("pleaseInputCorrect", { key: t("translation:apply.step3.section1.Q1") })}</FormInputError>
          </FormField>

          <FormField style={{ marginBottom: 0, width: "100%" }}>
            <FormLabelBold htmlFor="step3_email_confirm">{t("translation:apply.step3.section1.Q2")}</FormLabelBold>
            <FormInput id="step3_email_confirm" value={step3_email_confirm} onPaste={(e) => {
              e.preventDefault()
              return false;
            }} handleChange={e => {
              setStep3_email_confirm(e.target.value.toLowerCase());
              setStep3_email_confirm_error(false);
              validateStep3(true);
            }} placeholder={t("pleaseInput", { key: t("translation:apply.step3.section1.Q2") })} aria-label={t("translation:apply.step3.section1.Q2")} />
            <FormInputError show={step3_email_confirm_error}>* {t("pleaseInput", { key: t("translation:apply.step3.section1.Q2") })}</FormInputError>
          </FormField>

          <FormField ref={nodeRefMobile} style={{ marginBottom: 0, width: "100%", scrollMarginTop: 230 }}>
            <FormLabelBold htmlFor="step3_mobile">{t("translation:apply.step3.section1.Q3")}</FormLabelBold>
            <FormInput id="step3_mobile" value={step3_mobile} onPaste={(e) => {
              e.preventDefault()
              return false;
            }} handleChange={e => {
              const mobileReg = /^[0-9]+$/;

              if (mobileReg.test(e.target.value) || e.target.value === "") {
                setStep3_mobile(e.target.value);
                setStep3_mobile_error(false);
                validateStep3(true);
              }
            }} placeholder={t("pleaseInput", { key: t("translation:apply.step3.section1.Q3") })} aria-label={t("translation:apply.step3.section1.Q3")} />
            <FormInputError show={step3_mobile_error}>* {t("pleaseInputCorrect", { key: t("translation:apply.step3.section1.Q3") })}</FormInputError>
          </FormField>

          <FormField style={{ marginBottom: 0, width: "100%" }}>
            <FormLabelBold htmlFor="step3_mobile_confirm">{t("translation:apply.step3.section1.Q4")}</FormLabelBold>
            <FormInput id="step3_mobile_confirm" value={step3_mobile_confirm} onPaste={(e) => {
              e.preventDefault()
              return false;
            }} handleChange={e => {
              const mobileReg = /^[0-9]+$/;

              if (mobileReg.test(e.target.value) || e.target.value === "") {
                setStep3_mobile_confirm(e.target.value.toLowerCase());
                setStep3_mobile_confirm_error(false);
                validateStep3(true);
              }
            }} placeholder={t("pleaseInput", { key: t("translation:apply.step3.section1.Q4") })} aria-label={t("translation:apply.step3.section1.Q4")} />
            <FormInputError show={step3_mobile_confirm_error}>* {t("pleaseInput", { key: t("translation:apply.step3.section1.Q4") })}</FormInputError>
          </FormField>
        </Section>

      {
      false &&
        <Section>
          <Flex gap={8} align="center">
            <Img32 src={`${process.env.PUBLIC_URL}/images/pre-approval.svg`} alt={t("translation:apply.step3.section2.title")} />
            <FormTitle>{t("translation:apply.step3.section2.title")}</FormTitle>
          </Flex>

          <FormText>{t("translation:apply.step3.section2.subtitle")}</FormText>

          <FormField ref={nodeRefSync} style={{ marginBottom: 0, width: "100%", scrollMarginTop: 40 }}>
            <FormLabel htmlFor="sync" style={{ gap: 8 }}>
              <Switch id="sync" value={step3_sync} onChange={() => {
                setStep3_sync(!step3_sync);
                validateStep3(true);
              }} style={{ width: "fit-content" }} />
              <FormText style={{ cursor: "pointer" }}>{t("translation:apply.step3.section2.Q1")}</FormText>
            </FormLabel>
          </FormField>

          {
            step3_sync &&
            <SyncContainer>
              <Flex gap={24} vertical style={{ width: "100%" }}>
                <FormField style={{ flex: 0, width: "100%", marginBottom: 0, scrollMarginTop: 90 }}>
                  <Flex gap={8} style={{ width: "100%" }}>
                    <FormLabel htmlFor="sync_evaluation_policyno" style={{ marginBottom: 4 }}>{t("translation:apply.step0.sectionLeft.Q1")}</FormLabel>
                    <InformationIcon onClick={() => {
                      window.open(`http://bluecross.com.hk/document/general/supercare_find_policyno/${i18n.language}`, "_blank");
                    }}>i</InformationIcon>
                  </Flex>
                  <FormInput id="sync_evaluation_policyno" value={step3_Q1} handleChange={(e) => {
                    setStep3_Q1(e.target.value);
                    setStep3_Q1Error(false);
                    validateStep3(true);
                  }} placeholder={t("translation:apply.step0.sectionLeft.Q1_placeholder")} aria-label={t("translation:apply.step0.sectionLeft.Q1_placeholder")} />
                  <FormInputError show={step3_Q1Error}>* {t("pleaseEnter", { key: t("translation:apply.step0.sectionLeft.Q1") })}</FormInputError>
                </FormField>

                <FormField style={{ flex: 0, width: "100%", marginBottom: 0 }}>
                  <FormLabel style={{ marginBottom: 4 }}>{t("translation:apply.step0.sectionLeft.Q4")}</FormLabel>
                  <Flex vertical={isMobileView} gap={16}>
                    <FormBigCheckbox2
                      onClick={(event) => {
                        event.preventDefault();
                        handleOptionClick(1)
                        validateStep3(true);
                      }}
                      active={step3_Q4 === "person"}
                      title={t("translation:apply.step0.sectionLeft.Q4_Option1")}
                      style={{ flex: 1 }}
                      id="sync_evaluation_policyno_oneselft"
                    />
                    <FormBigCheckbox2
                      onClick={(event) => {
                        event.preventDefault();
                        handleOptionClick(2)
                        validateStep3(true);
                      }}
                      active={step3_Q4 === "spouse_children"}
                      title={t("translation:apply.step0.sectionLeft.Q4_Option2")}
                      style={{ flex: 1 }} 
                      id="sync_evaluation_policyno_spouse"
                    />
                  </Flex>
                </FormField>

                <CSSTransition
                  nodeRef={nodeRef1}
                  in={step3_Q4 === "person"}
                  timeout={250}
                  classNames="fade"
                  unmountOnExit
                  exit={false}
                >
                  <FormField style={{ flex: 0, width: "100%", marginBottom: 0 }}>
                    <Flex gap={8}>
                      <FormLabel htmlFor="sync_evaluation_policyno_member_number" style={{ marginBottom: 4 }}>{t("translation:apply.step0.sectionLeft.Q5")}</FormLabel>
                    </Flex>
                    <FormInput id="sync_evaluation_policyno_member_number" value={step3_Q5} handleChange={(e) => {
                      setStep3_Q5Error(false);
                      setStep3_Q5(e.target.value);
                      validateStep3(true);
                    }} placeholder={t("translation:apply.step0.sectionLeft.Q5_placeholder")} aria-label={t("translation:apply.step0.sectionLeft.Q5_placeholder")} />
                    <FormInputError show={step3_Q5Error}>* {t("pleaseEnter", { key: t("translation:apply.step0.sectionLeft.Q5") })}</FormInputError>
                  </FormField>
                </CSSTransition>

                <CSSTransition
                  nodeRef={nodeRef2}
                  in={step3_Q4 === "spouse_children"}
                  timeout={250}
                  classNames="fade"
                  unmountOnExit
                  exit={false}
                >
                  <>
                    <FormField style={{ flex: 0, width: "100%", marginBottom: 0 }}>
                      <Flex gap={8}>
                        <FormLabel htmlFor="sync_evaluation_policyno_application_insured_num" style={{ marginBottom: 4 }}>{t("translation:apply.step0.sectionLeft.Q6")}</FormLabel>
                      </Flex>
                      <FormInput id="sync_evaluation_policyno_application_insured_num" value={step3_Q6} handleChange={(e) => {
                        setStep3_Q6Error(false);
                        setStep3_Q6(e.target.value);
                        validateStep3(true); 
                      }} placeholder={t("translation:apply.step0.sectionLeft.Q6_placeholder")} aria-label={t("translation:apply.step0.sectionLeft.Q6_placeholder")} />
                      <FormInputError show={step3_Q6Error}>* {t("pleaseEnter", { key: t("translation:apply.step0.sectionLeft.Q6") })}</FormInputError>
                    </FormField>

                    <FormField style={{ flex: 0, width: "100%", marginBottom: 0 }}>
                      <Flex gap={8}>
                        <FormLabel htmlFor="sync_evaluation_policyno_application_spouse_insured_num" style={{ marginBottom: 4 }}>{t("translation:apply.step0.sectionLeft.Q7")}</FormLabel>
                      </Flex>
                      <FormInput id="sync_evaluation_policyno_application_spouse_insured_num" value={step3_Q7} handleChange={(e) => {
                        setStep3_Q7Error(false);
                        setStep3_Q7(e.target.value);
                        validateStep3(true);
                      }} placeholder={t("translation:apply.step0.sectionLeft.Q7_placeholder")} aria-label={t("translation:apply.step0.sectionLeft.Q7_placeholder")} />
                      <FormInputError show={step3_Q7Error}>* {t("pleaseEnter", { key: t("translation:apply.step0.sectionLeft.Q7") })}</FormInputError>
                    </FormField>
                  </>
                </CSSTransition>
              </Flex>
            </SyncContainer>
          }
        </Section>
      }
        <Flex gap={8} vertical={isMobileView} style={{ width: "100%", margin: isMobileView ? "8px 0px" : "32px 0px", flexDirection: isMobileView ? "column-reverse" : "row" }}>
          <Flex flex={1} justify={isMobileView ? "center" : ""}>
            <SaveButton onClick={saveFormStep3} style={{ width: "fit-content" }}>
              <Img24 src={`${process.env.PUBLIC_URL}/images/floppy.svg`} alt="Save" />
              <SaveButtonText>{t("save")}</SaveButtonText>
            </SaveButton>
          </Flex>
          <Flex flex={1} justify="center">
            <FormButtonPrimary id={isProduction ? "pre_auth_next_step_btn_3" : "pre_auth_uat_next_step_btn_3"} $disabled={!isStep3Valid} disabled={!isStep3Valid} onClick={() => {
              if (validateStep3()) {
                goNextStep();
              }
            }} style={{ width: isMobileView ? "100%" : "fit-content" }}>{t("next")}</FormButtonPrimary>
          </Flex>
          <Flex flex={1}> </Flex>
        </Flex>
      </Content>
    </Container >
  );
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PageTitle = styled.div`
  background-image: url(${process.env.PUBLIC_URL}/images/bg_light_1.png);
  width: 100%;
  height: 100px;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PreviousPageBtnText = styled(FormText)`
  font-size: 16px;
  line-height: 26px;
  color: var(--aia-bx-dark-blue);
  font-weight: bold;
`;

const PreviousPageBtn = styled(FormButton)`
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding: 8px;
  width: fit-content;
`;

const Content = styled.div`
  max-width: 800px;
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Section = styled(ShadowBox)`
  flex-direction: column;
  align-items: self-start;
  padding: 24px;
  gap: 16px;
`;

const Area = styled(Flex)`
  width: 100%;
`;

const AreaTitle = styled(Divider)`
  width: 100%;
  border-block-start: 0 var(--aia-bx-medium-blue-20) !important;
`;

const FormLabelBold = styled(FormLabel)`
  font-weight: bold;
`;

const SaveButton = styled.button`
  flex: 0;
  display: flex;
  align-items: center;
  background-color: transparent;
  border-radius: 10px;
  color: var(--aia-bx-blue-2);
  gap: 3px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  padding: 10px;

  &:hover {
    background-color: var(--aia-bx-bright-blue-5);
  }
`;

const SaveButtonText = styled.div`
  font-weight: bold;
  font-size: 14px;
  line-height: 24px;
  margin-left: 3px;
  text-wrap: nowrap;
  color: var(--aia-bx-dark-blue);
`;

const Img24 = styled.img`
  width: 24px;
  height: 24px;
`;

const Img32 = styled.img`
  width: 32px;
  height: 32px;
`;

const Terms = styled(Flex)`
  width: 100%;
  background-color: var(--aia-bx-gray-10);
  border-radius: 8px;
  padding: 16px;
  gap: 16px;
  flex-direction: column;
`;

const InformationIcon = styled(Flex)`
  background-color: var(--aia-bx-blue-2);
  color: var(--aia-bx-white);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  line-height: 0px;
  cursor: pointer;
  margin-bottom: 8px;
  &:hover {
    background-color: var(--aia-bx-blue-6);
  }
`;

const SyncContainer = styled(Flex)`
  width: 100%;
  background-color: var(--aia-bx-gray-10);
  border-radius: 8px;
  padding: 16px;
  gap: 16px;
`;

export default Step3;